<template>
  <button
    class="walletConnect-btn"
    @click="handleButtonClick"
  >
    <WalletconnectIcon />
  </button>
</template>

<script setup>
import WalletconnectIcon from "@/components/icons/Walletconnect.vue";
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from "@web3modal/html";
import { configureChains, createConfig } from '@wagmi/core'
import { useGlobalStore } from "@/stores/globalStore";
import * as EvmChains from '@wagmi/core/chains'
import { getAccount, disconnect } from '@wagmi/core'

const globalStore = useGlobalStore();

const props = defineProps({
  evmChainId: {
    type: Number,
    required: true,
    default: 1,
  }
});

const emit = defineEmits(["updateWallet"]);

const getEvmChain = (chainIdHex) => {
  const chainId = parseInt(chainIdHex, 16);
  const evmChains = Object.values(EvmChains);
  const filteredChain = evmChains.filter((evmChain) => {
    return evmChain.id ? evmChain.id === chainId : false; 
  });
  return filteredChain.length > 0 ? filteredChain[0] : null;
}

const handleButtonClick = async () => {
  // Handle button click
  const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID;
  const themeMode = globalStore.getIsLightMode ? "light" : "dark";
  let selectedChain = getEvmChain(props.evmChainId);
  if (selectedChain === null) {
    // Put mainnet as default if it's not found
    selectedChain = EvmChains.mainnet;
  }
  const chains = [selectedChain];
  const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
  const wagmiConfig = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({projectId, version: 2, chains}),
    publicClient
  });
  const ethereumClient = new EthereumClient(wagmiConfig, chains);
  const web3modal = new Web3Modal({ 
    projectId,
    themeMode,
  }, ethereumClient);
  web3modal.setDefaultChain(selectedChain);
  await web3modal.openModal("SelectNetwork");

  web3modal.subscribeEvents((event) => {
    if (event.name === "ACCOUNT_CONNECTED"){
      const connectedAccount = getAccount();
      emit("update-wallet", connectedAccount.address);
      disconnect();
    }
  });
};

</script>

<style lang="scss">
.walletConnect-btn {
  width: 6rem;
  aspect-ratio: 1 / 1;
  background: var(--input-background);
  border-radius: $border-radius;
  cursor: pointer;
  position: relative;
  border: 2px solid var(--input-background);
  transition: background 250ms;

  &:hover {
    background: var(--background);
  }

  &:active {
    background: rgb(255, 231, 208);
  }

  svg {
    width: 2.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
